import React from "react";
import { Scale, MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/mock";

export default function Header() {
  return (
    <header className="sticky top-0 z-40 w-full border-b border-[#e2dccb] bg-[#fcfbf6]/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between px-5 md:px-10">
        {/* Logo */}
        <a href="/" className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-md bg-[#0e1a2b]">
            <Scale className="h-5 w-5 text-[#b89c60]" strokeWidth={2.6} />
          </div>
          <div className="flex flex-col leading-tight">
            <span className="font-serif-display text-[18px] text-[#0e1a2b]">Pires Advogados</span>
            <span className="text-[11px] font-semibold tracking-widest-custom uppercase text-[#6a7889]">
              Restituição de ITBI · São Paulo
            </span>
          </div>
        </a>

        {/* Center - OAB number */}
        <div className="hidden md:block">
          <span className="text-[12px] tracking-widest-custom text-[#54657a]">OAB/SP 406.256</span>
        </div>

        {/* CTA Button */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-md bg-[#16a34a] px-4 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-[#15803d]"
        >
          <MessageCircle className="h-4 w-4" strokeWidth={2.6} />
          <span className="hidden sm:inline">Falar pelo WhatsApp</span>
          <span className="sm:hidden">WhatsApp</span>
        </a>
      </div>
    </header>
  );
}
